export default __webpack_public_path__ + "static/09-391c23fafccff027027b07ee1e6e30bf.jpg";